<template>
  <div class="trade-account-table">
    <van-row class="table-header" style="display: none;">
      <van-col :span="5">{{ $t("assets.rcdnum") }}</van-col>
      <van-col :span="4">{{ $t("assets.rcdstatus") }}</van-col>
      <van-col :span="6">{{ $t("assets.rcddesc") }}</van-col>
      <van-col :span="9" class="txt-right">{{ $t("assets.rcdtime") }}</van-col>
    </van-row>
    <div class="data-box" v-if="list.length > 0">
      <van-pull-refresh
        :pulling-text="$t('common.pulling')"
        :loosing-text="$t('common.loosing')"
        :loading-text="$t('common.loading')"
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('common.nomore')"
          :loading-text="$t('common.loading')"
          :error-text="$t('common.errortxt')"
          @load="onLoad"
        >

          <div class="record-Horizontal-box" v-for="(item, index) in list"
          :key="index">
            <ul>
              <li>
                <div class="title">{{ $t("assets.rcdnum") }}</div>
                <div class="box-value">{{ item.mum }}</div>
              </li>
              <li>
                <div class="title">{{ $t("assets.rcdstatus") }}</div>
                <div class="box-value">{{
              item.status == 1
                ? $t("common.status1")
                : item.status == 2
                ? $t("common.status2")
                : item.status == 3
                ? $t("common.status3")
                : item.status
            }}</div>
              </li>
              <li>
                <div class="title">{{ $t("assets.rcddesc") }}</div>
                <div class="box-value">{{ item.remark }}</div>
              </li>
       
              <li>
                <div class="title">{{ $t("assets.rcdtime") }}</div>
                <div class="box-value">{{ item.updatetime }}</div>
              </li>
            </ul>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div v-else class="data-box">
      <van-empty :description="$t('common.nodata')" />
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "WithdrawalTable",
  props: ["cid", "type"],
  computed: {
    safeCid() {
      return this.cid || "";
    },
    safeType() {
      return this.type || "";
    },
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      limit: 10,
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    showtips(msg){
      if(msg && msg.length > 0)
        this.$toast(msg)
    },
    onLoad() {
      this.getData();
    },
    async getData() {
      await this.$http({
        method: "post",
        url: "getWithdrawList",
        data: {
          c_id: this.safeCid,
          type: this.safeType,
          page: this.page,
          limit: this.limit,
        },
      }).then((res) => {
        this.refreshing = false;
        this.loading = false;
        if (res && res.data && res.data.list) {
          res.data.list.forEach((element) => {
            this.list.push(element);
          });
          if (res.data.list.length < this.limit) {
            this.finished = true;
          } else {
            this.page += 1;
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },
    onRefresh() {
      this.page = 1;
      this.list = [];
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
};
</script>
  
  <style>
</style>
  